/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.4.20",
    versionName: "0.2.0-nightly.2026.4.20",
    versionChannel: "nightly",
    buildDate: "2026-04-20T00:16:36.165Z",
    commitHash: "dcd031240aab44f8161e615b7f6d8aa86a1ee4de",
};
